"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import { useState } from "react"
import { useMutation } from "@apollo/client/react"
import { Button } from "@mui/material"
import { styled } from "@mui/material/styles"
import TherapistMessageModal from "../TherapistMessageModal"
import MessagingNotAvailableModal from "../MessagingNotAvailableModal"
import recordProviderContactAttempt from "../../../graphql/mutations/provider/recordProviderContactAttempt"
import * as Sentry from "@sentry/nextjs"

const CustomButton = styled(Button)(() => ({
  marginBottom: "20px",
  color: "#1a1a1a",
  backgroundColor: "#f0f0f0",
  boxShadow: "none",
  height: "52px",
  width: "300px",
  display: "flex",
  justifyContent: "center",
  padding: "0 25px",
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  fontFamily: "Inter, sans-serif",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "19px",
  textTransform: "unset",
  textAlign: "center",
  letterSpacing: "0.03em",
  borderRadius: "100px",
  "&:hover": {
    backgroundColor: "#e0e0e0",
  },
}))

export type TherapistMessageButtonWrapperProps = {
  formId: string
  cognitoId?: string | null
  providerId?: number | null
  userId?: number | null
  groupLeaderUserId?: number | null
  groupId?: number | null
  groupName?: string | null
  publicProviderMessageable?: boolean | null
  buttonText?: string
  isBAAModel?: boolean
}

export default function TherapistMessageButtonWrapper({
  formId,
  cognitoId,
  providerId,
  userId,
  groupLeaderUserId,
  groupId,
  groupName,
  publicProviderMessageable,
  buttonText = "Send Therapist Message",
  ...modalProps
}: TherapistMessageButtonWrapperProps) {
  const [open, setOpen] = useState(false)
  const [messagingNotAvailableOpen, setMessagingNotAvailableOpen] = useState(false)
  const [recordContactAttempt] = useMutation(recordProviderContactAttempt)

  const handleOpen = () => {
    if (publicProviderMessageable === false || publicProviderMessageable === null) {
      setMessagingNotAvailableOpen(true)

      // Notify the provider of the attempted contact (fire-and-forget; the
      // backend rate-limits to one email per provider per month)
      if (providerId) {
        recordContactAttempt({ variables: { iProviderId: providerId } }).catch(
          () => {},
        )
      }

      Sentry.captureException(
        new Error(
          "Attempted to open therapist message modal when provider messaging is disabled",
        ),
        {
          tags: {
            component: "TherapistMessageButtonWrapper",
            providerId,
            groupId,
          },
          extra: {
            publicProviderMessageable,
            providerId,
            groupId,
            groupName,
          },
        },
      )

      return
    }

    setOpen(true)
  }

  const handleClose = () => setOpen(false)

  return (
    <div className="flex flex-col justify-center items-center">
      <CustomButton onClick={handleOpen}>{buttonText}</CustomButton>
      {open && (
        <TherapistMessageModal
          open={open}
          onClose={handleClose}
          formId={formId}
          cognitoId={cognitoId}
          providerId={providerId}
          userId={userId}
          groupLeaderUserId={groupLeaderUserId}
          groupId={groupId}
          groupName={groupName}
          {...modalProps}
        />
      )}
      {messagingNotAvailableOpen && (
        <MessagingNotAvailableModal
          open={messagingNotAvailableOpen}
          onClose={() => setMessagingNotAvailableOpen(false)}
        />
      )}
    </div>
  )
}
